
import { Component, Vue } from 'vue-property-decorator';
import Logs from '~/components/Logs/index.vue';


@Component({
    components: {
        Logs,
    },
})
export default class SupportLogs extends Vue {

}
